__turbopack_context__.v({
  "accordionControl": "theme-module__bzqj8a__accordionControl",
  "accordionItem": "theme-module__bzqj8a__accordionItem",
  "buttonRoot": "theme-module__bzqj8a__buttonRoot",
  "cardRoot": "theme-module__bzqj8a__cardRoot",
  "checkboxInput": "theme-module__bzqj8a__checkboxInput",
  "codeRoot": "theme-module__bzqj8a__codeRoot",
  "dateTimePicker": "theme-module__bzqj8a__dateTimePicker",
  "dateTimePickerTime": "theme-module__bzqj8a__dateTimePickerTime",
  "dialogRoot": "theme-module__bzqj8a__dialogRoot",
  "dividerRoot": "theme-module__bzqj8a__dividerRoot",
  "drawerBody": "theme-module__bzqj8a__drawerBody",
  "drawerHeader": "theme-module__bzqj8a__drawerHeader",
  "hoverCardDropdown": "theme-module__bzqj8a__hoverCardDropdown",
  "inputInput": "theme-module__bzqj8a__inputInput",
  "menuDropdown": "theme-module__bzqj8a__menuDropdown",
  "menuItem": "theme-module__bzqj8a__menuItem",
  "modalContent": "theme-module__bzqj8a__modalContent",
  "modalHeader": "theme-module__bzqj8a__modalHeader",
  "notificationsNotification": "theme-module__bzqj8a__notificationsNotification",
  "notificationsRoot": "theme-module__bzqj8a__notificationsRoot",
  "paginationControl": "theme-module__bzqj8a__paginationControl",
  "scrollAreaScrollbar": "theme-module__bzqj8a__scrollAreaScrollbar",
  "skeletonRoot": "theme-module__bzqj8a__skeletonRoot",
  "table": "theme-module__bzqj8a__table",
  "tabsList": "theme-module__bzqj8a__tabsList",
  "tbody": "theme-module__bzqj8a__tbody",
  "thead": "theme-module__bzqj8a__thead",
  "tr": "theme-module__bzqj8a__tr",
});
